import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary({ defaultKeyword }) {
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [results, setResults] = useState(null);
  const [photos, setPhotos] = useState(null);

  const apiKey = "4bf39f80fc9d48003o92t3a6c3d6d47a";
  const pexelsKey = "YOUR_PEXELS_KEY";

  function search() {
    let url = `https://api.shecodes.io/dictionary/v1/define?word=${keyword}&key=${apiKey}`;
    axios.get(url).then((res) => setResults(res.data));

    let pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=6`;
    axios
      .get(pexelsUrl, { headers: { Authorization: pexelsKey } })
      .then((res) => setPhotos(res.data.photos));
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleChange(event) {
    setKeyword(event.target.value);
  }

  return (
    <div className="card">
      <form onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder="Search a word..."
          onChange={handleChange}
        />
        <button type="submit">Search</button>
      </form>

      {results && <Results results={results} />}
      {photos && <Photos photos={photos} />}
    </div>
  );
}